import _ from 'lodash';
import actions from '../actions/step';
import api_actions from '../actions/api';

import {findQuestions, getSchema, progressbar} from '../../utils/step.schema.utils';
import {progressbarRange} from '../../utils/step.fields.utils';
import axios from 'axios';
import {cleanPostcodeErrors, mapPostcodes} from "../../utils/redux.utils";

const updateState = (_state, action, new_data, name = null) => {
    let state = {..._state};
    if (!name) return state;
    state = {...state, ...new_data};
    return state;
};

const actionHandlers = {
    [actions.step_form_send_data]: (state, action) => {
        axios.defaults.withCredentials = false;
        const {name} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateState(state, action, {
                    isLoading: true,
                    errors: {},
                    vrmErrors: {},
                    postcodeErrors: {}
                }, name);
            case api_actions.api_end:
                return updateState(state, action, {isLoading: false}, name);
            default:
                return state;
        }
    },
    [actions.step_form_initial_data_succeeded]: (state, action, name) => {
        const _name = name.replace('step_', '');
        const {uuid, sources, lead_details: lead_data, state: lead_state, step} = action.payload;
        const _sources = sources ? sources : state.sources;
        const schema = getSchema(_name, {...(state.schema || {}), ...lead_data});


        let question = schema[0];
        let previousExist = false;

        const _progressbar = progressbar(schema, progressbarRange[_name]);


        if (step) {
            const {previous, current} = findQuestions(schema, {key: step}),
                _current = {...current} || null;
            if (_current && _current.children) delete _current.children;
            question = _current;

            //first question
            previousExist = !_.isEmpty(previous);
        }

        return updateState(state, action, {
            progressbar: {..._progressbar},
            schema,
            schemaData: lead_data,
            uuid,
            question,
            sources: _sources,
            lead_state,
            previousExist,
            errors: {},
            vrmErrors: {},
            postcodeErrors: {}
        }, name, lead_data);
    },
    [actions.step_form_failed]: (state, action) => {
        const {name} = action;
        let errors = _.get(action, 'payload.data.error');
        return updateState(state, action, {errors: !_.isEmpty(errors) ? errors : 'Please try later'}, name);
    },

    [actions.step_next_question_succeeded]: (state, action, name) => {
        const _name = name.replace('step_', '');
        const {step, state: lead_state, data: lead_data} = action.payload;
        const schema = getSchema(_name, {...(state.schema || {}), ...lead_data});

        let question = schema[0];
        let previousExist = false;

        if (step) {
            const {previous, current, next} = findQuestions(schema, {key: step}),
                _next = {...next} || null;

            if (_next && _next.children) delete _next.children;

            previousExist = !_.isEmpty(previous || current);
            question = _next;
        }

        return updateState(state, action, {schema, question, previousExist, lead_state}, name);
    },

    [actions.step_previous_question]: (state, action) => {
        const {name} = action,
            {question} = action.payload;
        const schema = getSchema(name.replace('step_', ''), state.schema);

        const {previous} = findQuestions(schema, question),
            prev = {...previous || null};
        if (prev && prev.children) delete prev.children;

        let previousExist = !_.isEmpty(prev);
        if (prev) {
            const {previous: beforePrevious} = findQuestions(schema, prev);
            previousExist = !_.isEmpty(beforePrevious);
        }

        return updateState(state, action, {schema, question: prev, previousExist}, name);
    },
    [actions.vrm_search]: (state, action) => {
        const {name} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateState(state, action, {vrmIsLoading: true, vrmErrors: {}}, name);
            case api_actions.api_end:
                return updateState(state, action, {vrmIsLoading: false}, name);
            default:
                return state;
        }
    },
    [actions.vrm_failed]: (state, action) => {
        const {name} = action;
        const errors = _.get(action, 'payload.data.error');
        return updateState(state, action, {vrmErrors: !_.isEmpty(errors) ? errors : 'Our vehicle lookup service is down, please enter manually'}, name);
    },
    [actions.vrm_succeeded]: (state, action) => {
        const {name} = action;
        return updateState(state, action, {vrmData: action.payload}, name);
    },

    [actions.postcode_search]: (state, action) => {
        const {name} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateState(state, action, {postcodeIsLoading: true, postcodeErrors: {}}, name);
            case api_actions.api_end:
                return updateState(state, action, {postcodeIsLoading: false}, name);
            default:
                return state;
        }
    },
    [actions.postcode_failed]: (state, action) => {
        const {name} = action;
        const errors = _.get(action, 'payload.data.error');
        const error = !_.isEmpty(errors) ? errors : 'Our postcode lookup service is down, please enter manually';
        const formErrors = cleanPostcodeErrors(_.get(state, 'errors', {}))

        return updateState(state, action, {
            postcodeErrors: error,
            mappedPostcodes: [],
            errors: {...formErrors, postcode: error}
        }, name);
    },
    [actions.postcode_succeeded]: (state, action) => {
        const {name} = action;
        const mappedPostcodes = mapPostcodes(action.payload);
        const errors = cleanPostcodeErrors(_.get(state, 'errors', {}))
        return updateState(state, action, {
            postcodeData: action.payload,
            mappedPostcodes,
            errors,
            postcodeErrors: {}
        }, name);
    },
    [actions.step_reset]: (state, action) => {
        return getDefaults();
    },
    [actions.step_update_schema_and_question]: (state, action) => {
            const {name, payload: {key, value}} = action;
            const schema = getSchema(name.replace('step_', ''));
            const {current} = findQuestions(schema, {key});
            if (current) return updateState(state, action, {question: {...current, value}}, name);
        return state;
    },

};

const stepReducer = (formName = '') => {
    return function form(state = getDefaults(), action) {
        const {name} = action;
        if (name !== formName) return state;
        if (actionHandlers[action.type]) return actionHandlers[action.type](state, action, name);
        return state;
    };
};

/*
state example:
    {
    'fresh_web_car':{
    uuid:''
    schema:{}
    ....
    }
 */
export function getDefaults() {
    return {}
}

export default stepReducer;
